module.exports = __webpack_public_path__ + "static/media/joffre-17.375c0bd3.jpg";